import { gqlFetcher, graphql } from '#features/api';
import { locales } from '../constants/locales';

const changeProfileLocaleDoc = graphql(`
  mutation ChangeProfileLocale {
    profile {
      changeLocale {
        status
      }
    }
  }
`);

// The page still has the previous locale until navigation. Override only this request,
// so the gateway saves the chosen language rather than the old URL's language.
export const changeProfileLocale = (locale: keyof typeof locales) =>
  gqlFetcher(changeProfileLocaleDoc, null, { headers: { Language: locale } });
